/* Harper "Find my size" : noyau pur (aucun DOM). Marche dans le navigateur et dans Node.
   Principe : AUCUN chiffre inventé. La taille conseillée sort UNIQUEMENT du guide de la fiche
   (colonne AU) et de ses variantes en vente. Si les deux ne s'accordent pas, la fiche est
   déclarée "non vérifiée" et l'outil ne s'affiche pas. */
(function (root) {
  var ALPHA = { XS: 'XS', S: 'S', M: 'M', L: 'L', XL: 'XL', XXL: '2XL', '2XL': '2XL', XXXL: '3XL', '3XL': '3XL',
    XXXXL: '4XL', '4XL': '4XL', XXXXXL: '5XL', '5XL': '5XL', '6XL': '6XL' };
  var NUM = '(\\d+(?:\\.\\d+)?)';
  var RANGE = new RegExp('^' + NUM + '(?:\\s*[\\/\\-\\u2013]\\s*' + NUM + ')?$');

  function clean(s) { return String(s == null ? '' : s).replace(/ /g, ' ').replace(/\s+/g, ' ').trim(); }

  function rangeOf(txt) {                       // "8", "8/10", "10-12", "6.5-7" -> [lo,hi] | null
    var m = RANGE.exec(clean(txt));
    if (!m) return null;
    var a = parseFloat(m[1]), b = m[2] != null ? parseFloat(m[2]) : a;
    if (b < a) return null;
    return [a, b];
  }

  /* Lit une cellule/étiquette de taille. Rend { alpha, au:[lo,hi], eu } ou null si rien d'australien n'est lisible.
     Formes vues dans le catalogue : "AU 12/14", "S (AU 8/10)", "S (10-12)", "10-12 (M)", "2XL (16)", "AU 6 (EU 36)", "6 (37)", "6" */
  function parseSize(raw) {
    var t = clean(raw).toUpperCase();
    if (!t) return null;
    var out = { alpha: null, au: null, eu: null, raw: clean(raw) };
    var m;
    // AU 5.5 (EU 35.5)
    m = /^AU\s*([\d.\/\-–\s]+?)\s*(?:\(\s*EU\s*([\d.\/\-–\s]+?)\s*\))?$/.exec(t);
    if (m) { out.au = rangeOf(m[1].replace(/\s+/g, '')); out.eu = m[2] ? rangeOf(m[2].replace(/\s+/g, '')) : null; return out.au ? out : null; }
    // S (AU 8/10)   |  S (10-12)  |  2XL (16)
    m = /^([0-9]?X{0,4}[SML]L?|[2-6]XL|XXL|XXXL)\s*\(\s*(?:AU\s*)?([\d.\/\-–\s]+?)\s*\)$/.exec(t);
    if (m && ALPHA[m[1]]) { out.alpha = ALPHA[m[1]]; out.au = rangeOf(m[2].replace(/\s+/g, '')); return out.au ? out : null; }
    // 10-12 (M)
    m = /^([\d.\/\-–\s]+?)\s*\(\s*([0-9]?X{0,4}[SML]L?|[2-6]XL)\s*\)$/.exec(t);
    if (m && ALPHA[m[2]]) { out.alpha = ALPHA[m[2]]; out.au = rangeOf(m[1].replace(/\s+/g, '')); return out.au ? out : null; }
    // chaussure "6 (37)" : AU d'abord, EU entre parenthèses
    m = /^([\d.]+(?:\s*[\-–\/]\s*[\d.]+)?)\s*\(\s*([\d.]+(?:\s*[\-–\/]\s*[\d.]+)?)\s*\)$/.exec(t);
    if (m) {
      out.au = rangeOf(m[1].replace(/\s+/g, '')); out.eu = rangeOf(m[2].replace(/\s+/g, ''));
      if (out.au && out.eu && out.au[0] >= 20 && out.eu[1] < 20) { var t2 = out.au; out.au = out.eu; out.eu = t2; }  // "35 (4)" = EU 35, AU 4
      return out.au ? out : null;
    }
    // lettre seule : pas d'AU
    if (ALPHA[t]) { out.alpha = ALPHA[t]; return out; }
    // nombre seul
    var r = rangeOf(t.replace(/\s+/g, ''));
    if (r) { out.au = r; return out; }
    return null;
  }

  /* Colonne guide -> table lisible. headers: ["Size","AU Size","Bust (cm)"...], rows: [[...],...] */
  function readGuide(headers, rows) {
    var H = headers.map(function (h) { return clean(h).toUpperCase(); });
    var iAU = -1, iSize = -1, iEU = -1;
    H.forEach(function (h, i) {
      if (iAU < 0 && (/^AU\b/.test(h) || /^SIZE\s*\(AU\)$/.test(h))) iAU = i;        // "AU Size", "AU", "Size (AU)"
      else if (iSize < 0 && /^(SIZE|LABEL|SHOE SIZE)$/.test(h)) iSize = i;
      if (iEU < 0 && /^EU( SIZE)?$/.test(h)) iEU = i;
    });
    // Colonne sans nom AU mais dont CHAQUE cellule s'écrit "AU n" (ex. "Fits : AU 12/14") : c'est la colonne AU.
    if (iAU < 0 && rows.length) H.forEach(function (h, i) {
      if (iAU >= 0 || i === iSize || i === iEU) return;
      var filled = rows.filter(function (r) { return clean(r[i]); });
      if (filled.length === rows.length && filled.every(function (r) { return /^AU\s*\d/i.test(clean(r[i])); })) iAU = i;
    });
    var kind = H.some(function (h) { return /FOOT/.test(h); }) ? 'shoe' : 'apparel';
    var res = [], problems = [], blocking = [];
    rows.forEach(function (r, ri) {
      var a = iAU >= 0 ? parseSize(r[iAU]) : null;
      var s = iSize >= 0 ? parseSize(r[iSize]) : null;
      var au = (a && a.au) || (s && s.au) || null;
      var alpha = (s && s.alpha) || (a && a.alpha) || null;
      if (a && a.au && s && s.au && (a.au[0] !== s.au[0] || a.au[1] !== s.au[1])) problems.push('ligne ' + (ri + 1) + ': colonne Size et colonne AU se contredisent (' + r[iSize] + ' / ' + r[iAU] + ')');
      var eu = null;
      if (iEU >= 0) {
        eu = rangeOf(clean(r[iEU]).replace(/^EU\s*/i, '').replace(/\s+/g, ''));
        if (!eu) { var pe = parseSize(r[iEU]); eu = (pe && pe.eu) || null; }      // cellule EU écrite "36 (4.5)"
      } else eu = (a && a.eu) || (s && s.eu) || null;
      // 12/10 : la colonne Size dit « 6 (37) » et la colonne EU dit 39 : la clé de correspondance elle-même est contestée.
      if (iEU >= 0 && s && s.eu && eu && (s.eu[0] !== eu[0] || s.eu[1] !== eu[1])) blocking.push('ligne ' + (ri + 1) + ': colonne Size et colonne EU se contredisent (' + clean(r[iSize]) + ' / ' + clean(r[iEU]) + ')');
      res.push({ cells: r, au: au, alpha: alpha, eu: eu, index: ri });
    });
    return { kind: kind, headers: headers, rows: res, problems: problems, blocking: blocking };
  }

  /* Variantes en vente : liste de valeurs de l'option Taille, ex. ["S (AU 8)","M (AU 10)"] */
  function readVariants(labels) {
    return labels.map(function (l) { var p = parseSize(l); return { label: l, alpha: p && p.alpha, au: p && p.au, eu: p && p.eu }; });
  }

  function overlaps(a, b) { return a[0] <= b[1] && b[0] <= a[1]; }
  function sameAu(a, b) { return !!a && !!b && a[0] === b[0] && a[1] === b[1]; }

  /* Contrôle de cohérence. Rend { ok, auMode, footMode, reasons[], scale[], map: row.index -> variant.label }
     ok       = chaque taille en vente retombe sur UNE ligne du guide (sinon l'outil ne s'affiche pas)
     auMode   = en plus, l'échelle australienne est prouvée (vêtement : colonnes AU d'accord ; chaussure : AU = EU - 31)
     footMode = chaussure dont les lignes portent une longueur de pied lisible */
  function footIndex(guide) { var k = -1; guide.headers.forEach(function (h, i) { if (k < 0 && /FOOT/i.test(h)) k = i; }); return k; }
  function footOf(guide, row) {
    var k = footIndex(guide); if (k < 0) return null;
    var m = /(\d+(?:[.,]\d+)?)/.exec(clean(row.cells[k])); return m ? parseFloat(m[1].replace(',', '.')) : null;
  }

  function verify(guide, variants) {
    var reasons = [], scale = [], map = {}, shoe = guide.kind === 'shoe', absent = [];
    if (!guide.rows.length) reasons.push('guide vide');
    guide.problems.forEach(function (p) { (shoe ? scale : reasons).push(p); });
    (guide.blocking || []).forEach(function (p) { reasons.push(p); });
    guide.rows.forEach(function (r, i) {
      if (shoe) {
        if (!r.eu && !r.au) reasons.push('ligne ' + (i + 1) + ': aucune pointure lisible (ni EU ni AU)');
        else if (!r.eu) scale.push('ligne ' + (i + 1) + ': pas de pointure EU lisible');
        else if (!r.au) scale.push('ligne ' + (i + 1) + ': pas de pointure AU lisible');
      }
      else if (!r.au) reasons.push('ligne ' + (i + 1) + ': pas de taille australienne lisible (' + clean(r.cells[0]) + ')');
    });
    if (reasons.length) return { ok: false, auMode: false, footMode: false, reasons: reasons, scale: scale, map: map };
    if (!shoe) for (var i = 1; i < guide.rows.length; i++) {
      var p = guide.rows[i - 1].au, c = guide.rows[i].au;
      if (c[0] < p[0] || c[1] < p[1]) reasons.push('barème non croissant entre ' + clean(guide.rows[i - 1].cells[0]) + ' et ' + clean(guide.rows[i].cells[0]));
    }
    // mesures qui reculent quand la taille monte = faute de frappe probable
    guide.headers.forEach(function (h, ci) {
      if (!/BUST|CHEST|WAIST|HIP|FOOT/i.test(h)) return;
      var prev = null;
      guide.rows.forEach(function (r) {
        var raw = clean(r.cells[ci]).replace(/,/, '.'); var m = /^(\d+(?:\.\d+)?)/.exec(raw);
        if (!m) return; var v = parseFloat(m[1]);
        if (prev !== null && v < prev - 0.01) reasons.push('mesure "' + clean(h) + '" qui recule entre deux tailles (' + prev + ' puis ' + v + ')');
        prev = v;
      });
    });
    if (!variants.length) reasons.push('aucune variante de taille');
    // variantes <-> lignes : vêtement par lettre puis AU ; chaussure par EU quand les DEUX côtés le portent partout,
    // sinon par la pointure AU (même nombre des deux côtés). Une correspondance par l'AU ne prouve pas l'échelle :
    // elle est notée dans `scale`, donc auMode reste faux et seule la longueur de pied (footMode) peut allumer l'outil.
    var shoeKey = 'eu';
    if (shoe) {
      var allEu = variants.length && variants.every(function (v) { return v.eu; }) && guide.rows.every(function (r) { return r.eu; });
      var allAu = variants.length && variants.every(function (v) { return v.au; }) && guide.rows.every(function (r) { return r.au; });
      if (!allEu && allAu) { shoeKey = 'au'; scale.push('pas d\'EU des deux côtés : correspondance par la pointure AU, échelle AU non prouvée'); }
    }
    variants.forEach(function (v) {
      var hit = null;
      guide.rows.forEach(function (r) {
        var match;
        if (shoe) match = shoeKey === 'au' ? (v.au && r.au && sameAu(v.au, r.au)) : (v.eu && r.eu && sameAu(v.eu, r.eu));
        else { var both = v.alpha && r.alpha; match = both ? v.alpha === r.alpha : (v.au && r.au && overlaps(v.au, r.au)); }
        if (match) hit = hit ? 'multi' : r;
      });
      if (hit === 'multi') { reasons.push('la variante "' + v.label + '" correspond à plusieurs lignes du guide'); return; }
      if (!hit) { reasons.push('la variante "' + v.label + '" n\'existe pas dans le guide'); absent.push(v.label); return; }
      if (map[hit.index]) { reasons.push('deux variantes pour la ligne ' + clean(hit.cells[0])); return; }
      map[hit.index] = v.label;
      if (v.au && !sameAu(v.au, hit.au)) (shoe ? scale : reasons).push('"' + v.label + '" dit AU ' + v.au.join('-') + ' mais le guide dit AU ' + hit.au.join('-') + ' pour ' + clean(hit.cells[0]));
    });
    if (shoe) guide.rows.forEach(function (r) {
      if (r.au && r.eu && (Math.abs(r.au[0] + 31 - r.eu[0]) > 0.01 || Math.abs(r.au[1] + 31 - r.eu[1]) > 0.01))
        scale.push('le guide dit AU ' + r.au[0] + ' = EU ' + r.eu[0] + ', l\'échelle australienne femme donne AU ' + (r.eu[0] - 31));
    });
    var ok = reasons.length === 0;
    var foot = shoe && ok && guide.rows.every(function (r) { return footOf(guide, r) != null; });
    return { ok: ok, auMode: ok && scale.length === 0, footMode: !!foot, reasons: reasons, scale: scale, map: map, absent: absent };
  }

  /* Mode partiel (décision du 21/10) : le guide n'a pas TOUTES les tailles vendues, et c'est sa SEULE faute.
     On vérifie la fiche sur les seules tailles présentes dans le guide (au moins 2), dans l'ordre du sélecteur.
     Les tailles vendues sans mesures sont rangées : sous la plus petite (below), au-dessus de la plus grande
     (above), ou dans un trou entre deux tailles du guide (gaps). Aucun conseil n'est jamais donné sur elles. */
  function verifyPartial(guide, variants) {
    var full = verify(guide, variants);
    full.partial = null;
    if (full.ok || !full.absent || !full.absent.length || full.reasons.length !== full.absent.length) return full;
    var kept = [], keptPos = [], absentPos = [];
    variants.forEach(function (v, i) { if (full.absent.indexOf(v.label) < 0) { kept.push(v); keptPos.push(i); } else absentPos.push(i); });
    if (kept.length < 2) return full;
    var v2 = verify(guide, kept);
    if (!v2.ok || !(v2.auMode || v2.footMode)) return full;
    // ligne du guide de chaque taille gardée, dans l'ordre du sélecteur : elle doit monter avec lui
    var rowOf = {}; Object.keys(v2.map).forEach(function (k) { rowOf[v2.map[k]] = parseInt(k, 10); });
    var rows = kept.map(function (v) { return rowOf[v.label]; });
    for (var i = 1; i < rows.length; i++) if (!(rows[i] > rows[i - 1])) return full;
    var p = { below: [], above: [], gaps: [] };
    absentPos.forEach(function (ai) {
      var label = variants[ai].label;
      if (ai < keptPos[0]) { p.below.push(label); return; }
      if (ai > keptPos[keptPos.length - 1]) { p.above.push(label); return; }
      for (var j = 0; j < keptPos.length - 1; j++) if (ai > keptPos[j] && ai < keptPos[j + 1]) {
        var g = p.gaps.filter(function (x) { return x.lo === rows[j]; })[0];
        if (!g) { g = { lo: rows[j], hi: rows[j + 1], labels: [] }; p.gaps.push(g); }
        g.labels.push(label);
      }
    });
    // barème « à cheval » (S 8/10, M 10/12) : prouvé seulement par deux tailles du guide VOISINES dans le sélecteur.
    // Sans preuve, on le suppose à cheval : c'est le cas qui retire le plus de conseils, jamais celui qui en invente.
    var adj = [];
    for (var k = 1; k < kept.length; k++) {
      var trou = p.gaps.some(function (g) { return g.lo === rows[k - 1]; });
      if (!trou) adj.push([guide.rows[rows[k - 1]], guide.rows[rows[k]]]);
    }
    p.overlap = !adj.length || adj.some(function (a) { return a[0].au && a[1].au && a[0].au[1] >= a[1].au[0]; });
    p.absent = full.absent.slice();
    v2.partial = p;
    v2.reasons = full.reasons;   // pour l'audit : ce qui manque au guide
    return v2;
  }

  /* Le conseil tombe-t-il dans une zone sans mesures ? r = sortie de recommend / recommendByFoot.
     Rend true quand la bonne taille pourrait être une taille vendue sans mesures : alors on n'en propose aucune. */
  function partialBlind(guide, v, r, mode, value) {
    var p = v.partial; if (!p) return false;
    var mapped = guide.rows.filter(function (row) { return v.map[row.index] != null; });
    var first = mapped[0], last = mapped[mapped.length - 1];
    var gapAbove = function (row) { return (row === last && p.above.length) || p.gaps.some(function (g) { return g.lo === row.index; }); };
    var gapBetween = function (a, b) { return p.gaps.some(function (g) { return g.lo === a.index && g.hi === b.index; }); };
    if (r.status === 'above') return p.above.length > 0;
    if (mode === 'foot') {
      if (r.status === 'below') return p.below.length > 0;
      if (r.status === 'exact') return false;
      return !!(r.alt && r.alt[0] && gapBetween(r.alt[0], r.pick));
    }
    if (r.status === 'below') return p.below.length > 0 && first && value < first.au[0];
    // AU : sur un barème à cheval, la borne HAUTE d'une taille dont la voisine du dessus n'a pas de mesures
    // est partagée avec cette voisine, et « size up » la choisirait : pas de conseil.
    if (r.pick && p.overlap && gapAbove(r.pick) && value >= r.pick.au[1]) return true;
    if (r.pick && r.alt && r.alt[0] && gapBetween(r.alt[0], r.pick)) return true;
    return false;
  }

  /* La reco. auSize: nombre (ex. 12, 5.5). Règle d'égalité : entre deux tailles, la plus grande
     (c'est la règle déjà écrite dans les guides Harper : "If between sizes, size up"). */
  function recommend(guide, map, auSize) {
    var cand = guide.rows.filter(function (r) { return map[r.index] != null; });
    var hits = cand.filter(function (r) { return auSize >= r.au[0] && auSize <= r.au[1]; });
    if (hits.length) {
      hits.sort(function (a, b) { return (b.au[0] + b.au[1]) - (a.au[0] + a.au[1]); });
      return { status: hits.length > 1 ? 'between' : 'exact', pick: hits[0], alt: hits.slice(1) };
    }
    var lo = cand[0], hi = cand[cand.length - 1];
    if (auSize < lo.au[0]) return { status: 'below', edge: lo };
    if (auSize > hi.au[1]) return { status: 'above', edge: hi };
    var below = null, above = null;
    cand.forEach(function (r) { if (r.au[1] < auSize) below = r; if (r.au[0] > auSize && !above) above = r; });
    return { status: 'between', pick: above, alt: below ? [below] : [] };   // demi-pointure / taille non listée : on monte
  }

  /* Chaussure : longueur de pied mesurée (cm). La plus petite ligne dont la longueur est >= la mesure ; entre deux, on monte. */
  function recommendByFoot(guide, map, cm) {
    var cand = guide.rows.filter(function (r) { return map[r.index] != null && footOf(guide, r) != null; })
      .sort(function (a, b) { return footOf(guide, a) - footOf(guide, b); });
    var min = cand[0], max = cand[cand.length - 1];
    if (cm > footOf(guide, max) + 0.001) return { status: 'above', edge: max };
    var pick = null; cand.forEach(function (r) { if (!pick && footOf(guide, r) >= cm - 0.001) pick = r; });
    var idx = cand.indexOf(pick), alt = idx > 0 ? [cand[idx - 1]] : [];
    var exact = Math.abs(footOf(guide, pick) - cm) < 0.001;
    return { status: cm < footOf(guide, min) ? 'below' : (exact ? 'exact' : 'between'), pick: pick, alt: alt, edge: min };
  }

  var api = { parseSize: parseSize, readGuide: readGuide, readVariants: readVariants, verify: verify, verifyPartial: verifyPartial, partialBlind: partialBlind, recommend: recommend, recommendByFoot: recommendByFoot, footOf: footOf, clean: clean };
  if (typeof module !== 'undefined' && module.exports) module.exports = api; else root.HarperFinder = api;
})(typeof window !== 'undefined' ? window : this);
/* Harper "Find my size" : interface du pop-up. Dépend de HarperFinder (finder-core.js).
   open({ tableHtml, variantLabels, onSelect, frame }) ouvre le pop-up "Size Guide".
   Si la fiche n'est pas vérifiée, le pop-up reste le guide simple d'aujourd'hui (aucun conseil affiché). */
(function (root) {
  var F = root.HarperFinder;
  var CSS = [
    '.hfx-modal{position:fixed;inset:0;z-index:2147483647;display:flex;align-items:center;justify-content:center;padding:14px;font-family:inherit;color:#1a1a1a}',
    '.hfx-modal.hfx-in-frame{position:absolute}',
    '.hfx-modal *{box-sizing:border-box}',
    '.hfx-ov{position:absolute;inset:0;background:rgba(0,0,0,.55)}',
    '.hfx-box{position:relative;container-type:inline-size;background:#fff;border-radius:12px;width:100%;max-width:540px;max-height:90%;overflow-y:auto;padding:26px 18px 20px;box-shadow:0 20px 50px rgba(0,0,0,.22)}',
    '.hfx-x{position:absolute;top:6px;right:6px;background:none;border:none;cursor:pointer;width:44px;height:44px;display:flex;align-items:center;justify-content:center;color:#1a1a1a;padding:0}',
    '.hfx-h{font-size:clamp(1.3rem,5cqw,1.7rem);font-weight:800;text-align:center;margin:0 0 16px;letter-spacing:.03em;text-transform:uppercase}',
    '.hfx-find{border:1px solid #1a1a1a;border-radius:8px;padding:16px 14px 14px;margin:0 0 20px;background:#fff}',
    '.hfx-kick{margin:0 0 4px;font-size:11px;letter-spacing:.07em;text-transform:uppercase;font-weight:700}',
    '.hfx-q{margin:0 0 10px;font-size:15px;font-weight:600}',
    '.hfx-chips{display:grid;grid-template-columns:repeat(auto-fill,minmax(52px,1fr));gap:8px}',
    '.hfx-chip{height:44px;min-height:44px;border:1px solid #1a1a1a;border-radius:6px;background:#fff;color:#1a1a1a;font-weight:600;font-size:15px;line-height:1;font-family:inherit;cursor:pointer;padding:0}',
    '.hfx-chip:hover{background:#f1f1ee}',
    '.hfx-chip[aria-pressed=true]{background:#1a1a1a;color:#fff}',
    '.hfx-chip--other{font-size:13px;font-weight:600}',
    '.hfx-chip:focus-visible,.hfx-btn:focus-visible,.hfx-alt:focus-visible,.hfx-in:focus-visible{outline:2px solid #1a1a1a;outline-offset:2px}',
    '.hfx-foot{display:flex;gap:8px;align-items:stretch}',
    '.hfx-in{flex:1;min-width:0;height:44px;border:1px solid #1a1a1a;border-radius:6px;padding:0 12px;font-weight:600;font-size:16px;line-height:1;font-family:inherit}',
    '.hfx-go{height:44px;padding:0 18px;border:1px solid #1a1a1a;border-radius:6px;background:#1a1a1a;color:#fff;font-weight:700;font-size:14px;line-height:1;font-family:inherit;cursor:pointer}',
    '.hfx-tip{margin:8px 0 0;font-size:12px;color:#666;line-height:1.4}',
    '.hfx-res{margin-top:14px}',
    '.hfx-card{border-left:4px solid #1a1a1a;background:#f4f3ef;border-radius:0 8px 8px 0;padding:14px 14px 14px 14px}',
    '.hfx-card.hfx-none{border-left-color:#999}',
    '.hfx-top{margin:0;font-size:12px;letter-spacing:.06em;text-transform:uppercase;color:#555;font-weight:700}',
    '.hfx-big{margin:2px 0 6px;font-size:clamp(1.4rem,7cqw,1.8rem);font-weight:800;line-height:1.15}',
    '.hfx-sub{margin:0 0 8px;font-size:13.5px;line-height:1.45}',
    '.hfx-meas{display:flex;flex-wrap:wrap;gap:4px 14px;margin:0 0 12px;font-size:13px}',
    '.hfx-meas b{font-weight:700}',
    '.hfx-btn{display:block;width:100%;height:46px;border:none;border-radius:6px;background:#1a1a1a;color:#fff;font-weight:700;font-size:15px;line-height:1;font-family:inherit;cursor:pointer}',
    '.hfx-alt{display:block;margin:10px 0 0;padding:6px 0;background:none;border:none;color:#1a1a1a;font-weight:600;font-size:13px;line-height:1.3;font-family:inherit;text-decoration:underline;text-underline-offset:2px;cursor:pointer;text-align:left}',
    '.hfx-src{margin:10px 0 0;font-size:11px;color:#777}',
    '.hfx-lbl{margin:0 0 11px;font-size:11px;letter-spacing:.07em;text-transform:uppercase;font-weight:600}',
    '.hfx-scroll{max-width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch;border:1px solid #1a1a1a;border-radius:6px}',
    '.hfx-scroll table{width:auto;min-width:100%;border-collapse:collapse;font-size:13px;line-height:1.25}',
    '.hfx-scroll th{background:#1a1a1a;color:#fff;padding:9px 10px;font-weight:600;font-size:10.5px;letter-spacing:.01em;text-transform:uppercase;text-align:center;white-space:normal}',
    '.hfx-scroll td{padding:9px 10px;text-align:center;border-top:1px solid #ededed;background:#fff;color:#1a1a1a;white-space:nowrap}',
    '.hfx-scroll th:first-child,.hfx-scroll td:first-child{text-align:left;font-weight:600;white-space:nowrap}',
    '.hfx-scroll tbody tr:nth-child(even) td{background:#fafafa}',
    '.hfx-scroll tr.hfx-hit td{background:#ebe7da!important;font-weight:700;box-shadow:inset 0 0 0 0 #1a1a1a}',
    '.hfx-scroll tr.hfx-hit td:first-child{box-shadow:inset 4px 0 0 #1a1a1a}',
    '.hfx-scroll tr.hfx-alt-row td{background:#f6f4ec!important}',
    '.hfx-note{font-size:11px;color:#888;margin:10px 0 0;font-style:italic;text-align:center}',
    '@container (max-width:460px){.hfx-chips{grid-template-columns:repeat(5,1fr)}.hfx-scroll table{font-size:12px}.hfx-scroll th{font-size:9.5px;padding:8px 7px;letter-spacing:0}.hfx-scroll td{padding:8px 7px}.hfx-find{padding:14px 12px 12px}}'
  ].join('\n');

  function injectCss() {
    if (document.getElementById('hfx-css')) return;
    var s = document.createElement('style'); s.id = 'hfx-css'; s.textContent = CSS; document.head.appendChild(s);
  }
  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function readTable(tbl) {
    var heads = [].map.call(tbl.querySelectorAll('thead th'), function (th) { return F.clean(th.textContent); });
    var rows = [].map.call(tbl.querySelectorAll('tbody tr'), function (tr) { return [].map.call(tr.querySelectorAll('td'), function (td) { return F.clean(td.textContent); }); });
    return { heads: heads, rows: rows };
  }

  function fmtAu(r) { return r.au[0] === r.au[1] ? String(r.au[0]) : r.au[0] + '/' + r.au[1]; }

  /* Mesures de la ligne : toutes les colonnes qui ne sont ni la taille, ni l'AU, ni l'EU */
  function measures(guide, row) {
    var out = [];
    guide.headers.forEach(function (h, i) {
      if (/^(SIZE|LABEL|AU\b|EU\b)/i.test(F.clean(h))) return;
      var v = F.clean(row.cells[i]); if (!v) return;
      var u = /\(([a-z]+)\)/i.exec(F.clean(h));             // unité de la colonne : (cm), (kg), (in)
      var name = F.clean(h).replace(/\s*\([a-z]+\)\s*/i, '');
      var unit = /[a-z]/i.test(v) ? '' : ' ' + (u ? u[1].toLowerCase() : 'cm');
      out.push('<span><b>' + esc(name) + '</b> ' + esc(v) + unit + '</span>');
    });
    return out.join('');
  }

  function open(opts) {
    injectCss();
    var wrap = document.createElement('div'); wrap.innerHTML = opts.tableHtml;
    var tbl = wrap.querySelector('table'); if (!tbl) return null;
    tbl.removeAttribute('class');   // le thème Harper vise .sgx-table en !important : sans la classe, seul le style du pop-up s'applique
    var data = readTable(tbl);
    var guide = F.readGuide(data.heads, data.rows);
    var variants = F.readVariants(opts.variantLabels || []);
    var v = F.verifyPartial(guide, variants);
    var mode = v.ok && v.auMode ? 'au' : (v.ok && v.footMode ? 'foot' : null);
    var shoe = guide.kind === 'shoe';
    var part = mode ? v.partial : null;   // 21/10 : tailles vendues sans mesures dans le guide
    var cm = !/\((?:in|inch|inches|kg|kgs|g|lb|lbs)\)/i.test(tbl.textContent);   // même test que l'ancien pop-up

    var modal = document.createElement('div');
    modal.className = 'hfx-modal' + (opts.frame ? ' hfx-in-frame' : '');
    modal.setAttribute('role', 'dialog'); modal.setAttribute('aria-modal', 'true'); modal.setAttribute('aria-label', 'Size guide');
    modal.innerHTML =
      '<div class="hfx-ov"></div><div class="hfx-box">' +
      '<button type="button" class="hfx-x" aria-label="Close"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M4 4l12 12M16 4L4 16"/></svg></button>' +
      '<p class="hfx-h">' + (mode ? 'Find my size' : 'Size Guide') + '</p>' +
      (mode ? '<section class="hfx-find" aria-label="Find your size"></section>' : '') +
      '<p class="hfx-lbl">' + (mode ? 'Full size guide' : 'Size Guide') + (cm ? ' (cm)' : '') + '</p>' +
      '<div class="hfx-scroll">' + tbl.outerHTML + '</div>' +
      (cm ? '<p class="hfx-note">All measurements in cm. Allow 1-2 cm tolerance.</p>' : '') + '</div>';
    (opts.frame || document.body).appendChild(modal);
    var prevOverflow = document.body.style.overflow;
    if (!opts.frame) document.body.style.overflow = 'hidden';

    function close() {
      modal.remove(); if (!opts.frame) document.body.style.overflow = prevOverflow;
      document.removeEventListener('keydown', onKey);
      if (opts.onClose) opts.onClose();
    }
    function onKey(e) { if (e.key === 'Escape') close(); }
    document.addEventListener('keydown', onKey);
    modal.querySelector('.hfx-ov').addEventListener('click', close);
    modal.querySelector('.hfx-x').addEventListener('click', close);

    var trs = [].slice.call(modal.querySelectorAll('.hfx-scroll tbody tr'));
    function mark(pick, alt) {
      trs.forEach(function (tr, i) {
        tr.classList.toggle('hfx-hit', !!pick && i === pick.index);
        tr.classList.toggle('hfx-alt-row', !!alt && alt.some(function (a) { return a.index === i; }));
      });
    }

    if (mode) {
      var sec = modal.querySelector('.hfx-find');
      var chosen = null;
      if (mode === 'au') {
        // Eric 12/10 : seulement les tailles AU que la fiche vend (pas de plage 6 à 24, jamais « not made »)
        var vals = {};
        guide.rows.forEach(function (r) {
          if (v.map[r.index] == null) return;
          vals[r.au[0]] = 1; vals[r.au[1]] = 1;
          if (!shoe) for (var x = r.au[0] + 2; x < r.au[1]; x += 2) vals[x] = 1;   // 8-12 couvre aussi 10
        });
        var list = Object.keys(vals).map(parseFloat).sort(function (a, b) { return a - b; });
        sec.innerHTML = '<p class="hfx-q">' + (shoe ? 'What size do you usually wear in Australia?' : 'What size do you usually wear in Australia?') + '</p>' +
          '<div class="hfx-chips" role="group" aria-label="Australian size">' + list.map(function (n) { return '<button type="button" class="hfx-chip" aria-pressed="false" data-au="' + n + '">' + n + '</button>'; }).join('') +
          (part ? '<button type="button" class="hfx-chip hfx-chip--other" aria-pressed="false" data-other="1" aria-label="My size is not listed">Other</button>' : '') + '</div>' +
          '<div class="hfx-res" aria-live="polite"></div>';
        sec.addEventListener('click', function (e) {
          var b = e.target.closest('.hfx-chip'); if (!b) return;
          [].forEach.call(sec.querySelectorAll('.hfx-chip'), function (c) { c.setAttribute('aria-pressed', c === b ? 'true' : 'false'); });
          if (b.hasAttribute('data-other')) { chosen = null; show({ status: 'none' }, 'Your size'); return; }
          chosen = parseFloat(b.getAttribute('data-au'));
          show(F.recommend(guide, v.map, chosen), 'AU ' + chosen, chosen);
        });
      } else {
        sec.innerHTML = '<p class="hfx-q">Your foot length (cm)</p>' +
          '<div class="hfx-foot"><input class="hfx-in" type="number" inputmode="decimal" min="15" max="35" step="0.1" placeholder="e.g. 23.5" aria-label="Foot length in centimetres"><button type="button" class="hfx-go">Find my size</button></div>' +
          '<p class="hfx-tip">Stand on a sheet of paper, mark your heel and your longest toe, then measure the gap in cm. Measure both feet and use the longer one.</p>' +
          '<div class="hfx-res" aria-live="polite"></div>';
        var input = sec.querySelector('.hfx-in');
        var go = function () { var n = parseFloat(String(input.value).replace(',', '.')); if (!isFinite(n) || n < 15 || n > 35) { sec.querySelector('.hfx-res').innerHTML = '<div class="hfx-card hfx-none"><p class="hfx-sub">Enter your foot length in centimetres, for example 23.5.</p></div>'; return; } show(F.recommendByFoot(guide, v.map, n), n + ' cm', n); };
        sec.querySelector('.hfx-go').addEventListener('click', go);
        input.addEventListener('keydown', function (e) { if (e.key === 'Enter') go(); });
      }

      var res = sec.querySelector('.hfx-res');
      var show = function (r, what, value) {
        var html = '', pick = r.pick, alt = r.alt || [];
        var name = function (row) { return esc(v.map[row.index]); };
        if (part && (r.status === 'none' || F.partialBlind(guide, v, r, mode, value))) {
          // jamais de taille devinée : la bonne taille pourrait être une taille vendue sans mesures
          html = '<div class="hfx-card hfx-none"><p class="hfx-top">' + esc(what) + '</p><p class="hfx-big">No measurements for this size</p>' +
            '<p class="hfx-sub">See the size chart below.' + (part.absent.length ? ' This item is also sold in ' + part.absent.map(esc).join(', ') + ', without measurements in its size guide.' : '') + '</p></div>';
          pick = null; alt = [];
        } else if (r.status === 'below' && mode === 'au') {
          html = '<div class="hfx-card hfx-none"><p class="hfx-top">' + esc(what) + '</p><p class="hfx-big">Not made this small</p><p class="hfx-sub">The smallest size on this item is <b>' + name(r.edge) + '</b>. Check the measurements below to see if it could still suit you.</p></div>';
          pick = null; alt = [r.edge];
        } else if (r.status === 'above') {
          html = '<div class="hfx-card hfx-none"><p class="hfx-top">' + esc(what) + '</p><p class="hfx-big">Not made this large</p><p class="hfx-sub">The largest size on this item is <b>' + name(r.edge) + '</b>. Check the measurements below to see if it could still suit you.</p></div>';
          pick = null; alt = [r.edge];
        } else {
          var sub;
          if (mode === 'foot') {
            var ft = F.footOf(guide, pick);
            sub = r.status === 'exact' ? 'A foot of ' + ft + ' cm matches this size exactly.' :
              (r.status === 'below' ? 'This is the smallest size on this item, for a foot up to ' + ft + ' cm.' : 'Your foot is ' + what + ', between two sizes. We suggest the larger one so your toes have room.');
          } else if (r.status === 'exact') {
            sub = 'On this item, ' + esc(what) + ' is a ' + name(pick) + '.';
          } else {
            sub = esc(what) + ' fits two sizes on this item. We suggest the larger one for comfort.';
          }
          html = '<div class="hfx-card"><p class="hfx-top">We recommend</p><p class="hfx-big">' + name(pick) + '</p><p class="hfx-sub">' + sub + '</p>' +
            '<div class="hfx-meas">' + measures(guide, pick) + '</div>' +
            '<button type="button" class="hfx-btn" data-pick="' + pick.index + '">Select size ' + name(pick) + '</button>' +
            (alt.length ? '<button type="button" class="hfx-alt" data-pick="' + alt[0].index + '">Prefer a closer fit? Choose ' + name(alt[0]) + ' instead</button>' : '') +
            '<p class="hfx-src">Based on the size guide of this item, shown below.</p></div>';
        }
        res.innerHTML = html;
        mark(pick, alt);
        var hit = trs[(pick || alt[0] || {}).index]; if (hit && hit.scrollIntoView && !opts.frame) { /* le tableau est visible juste dessous */ }
      };
      res.addEventListener('click', function (e) {
        var b = e.target.closest('[data-pick]'); if (!b) return;
        var label = v.map[parseInt(b.getAttribute('data-pick'), 10)];
        if (opts.onSelect) opts.onSelect(label);
        close();
      });
    }
    var first = modal.querySelector('.hfx-chip, .hfx-in, .hfx-x'); if (first) first.focus();
    return { verdict: v, mode: mode, close: close };
  }

  /* Mode de la fiche sans rien ouvrir : 'au', 'foot' ou null (non vérifiée). Sert à nommer le bouton. */
  function modeOf(tableHtml, variantLabels) {
    var wrap = document.createElement('div'); wrap.innerHTML = tableHtml;
    var tbl = wrap.querySelector('table'); if (!tbl) return null;
    var data = readTable(tbl);
    var v = F.verifyPartial(F.readGuide(data.heads, data.rows), F.readVariants(variantLabels || []));
    return v.ok && v.auMode ? 'au' : (v.ok && v.footMode ? 'foot' : null);
  }

  /* Pour l'audit : le verdict complet (mode partiel compris) sans rien ouvrir. */
  function verdictOf(tableHtml, variantLabels) {
    var wrap = document.createElement('div'); wrap.innerHTML = tableHtml;
    var tbl = wrap.querySelector('table'); if (!tbl) return null;
    var data = readTable(tbl);
    return F.verifyPartial(F.readGuide(data.heads, data.rows), F.readVariants(variantLabels || []));
  }

  root.HarperFinderUI = { open: open, modeOf: modeOf, verdictOf: verdictOf };
})(typeof window !== 'undefined' ? window : this);
/* Harper "Find my size" : branchement sur la fiche Horizon (agent PRODUIT, 19/10/2026, code neuf).
   Lit le guide de la fiche (.sgx .sgx-scroll, dans la description) et les tailles du sélecteur
   Harper (blocks/hz-produit-variantes.liquid) : fieldset.hz-option--taille, radios .hz-choix__radio.
   Fiche vérifiée : bouton « Not sure? Find my size » et pop-up Find my size.
   Sinon hfFinderOpen rend false et hfSgOpen ouvre le guide simple (snippets/harper-sgx-popup.liquid).
   Le sélecteur est re-rendu par Horizon à chaque changement de variante : le libellé du bouton
   est donc ré-appliqué à chaque re-rendu (observateur sur la fiche). */
(function () {
  if (window.hfFinderOpen) return;

  function context() {
    var btn = document.getElementById('sg-trigger');
    var sc = document.querySelector('.sgx .sgx-scroll');
    if (!btn || !sc || !sc.querySelector('table') || !window.HarperFinderUI) return null;
    var fs = btn.closest('fieldset.hz-option--taille');
    if (!fs) return null;
    var radios = [].slice.call(fs.querySelectorAll('input.hz-choix__radio'));
    var labels = radios.map(function (r) { return r.value; });
    var tableHtml = sc.querySelector('table').outerHTML;
    return { btn: btn, fs: fs, labels: labels, tableHtml: tableHtml, mode: window.HarperFinderUI.modeOf(tableHtml, labels) };
  }

  /* Coche la taille dans le sélecteur : un clic sur la radio déclenche le « change » qu'écoute Horizon. */
  function selectSize(label) {
    var c = context(); if (!c) return;
    var input = [].filter.call(c.fs.querySelectorAll('input.hz-choix__radio'), function (i) { return i.value === label; })[0];
    if (!input) return;
    if (!input.checked) input.click();
    var box = input.closest('label');
    if (box && box.scrollIntoView) box.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }

  window.hfFinderOpen = function () {
    var c = context();
    if (!c) return false;
    window.HarperFinderUI.open({ tableHtml: c.tableHtml, variantLabels: c.labels, onSelect: selectSize });
    return true;
  };

  function label() {
    var c = context();
    if (!c || !c.mode) return;
    if (c.btn.textContent !== 'Not sure? Find my size') c.btn.textContent = 'Not sure? Find my size';
    if (c.btn.getAttribute('aria-label') !== 'Find my size') c.btn.setAttribute('aria-label', 'Find my size');
  }

  function watch() {
    label();
    var picker = document.querySelector('variant-picker.hz-variantes');
    if (!picker || !window.MutationObserver) return;
    var queued = false;
    new MutationObserver(function () {
      if (queued) return; queued = true;
      requestAnimationFrame(function () { queued = false; label(); });
    }).observe(picker, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
})();
